import React from "react";
import { CurrencyDropdown, LabelledRow } from "../../components";
import { type BookkeepingCurrency as BookkeepingCurrencyType } from "components/exchangerate/hooks";
import ExchangeRatePickerTableRow from "components/exchangerate/ExchangeRatePickerTableRow";
import BookkeepingPaginatedDropdown from "components/dropdowns/paginated/BookkeepingPaginatedDropdown";

interface Props {
  bookkeepingCurrency: BookkeepingCurrencyType

  isBookkeepingDisabled?: boolean

  exchangeRateValidatorKey?: string
  exchangeRateError?: boolean
  rowRef?: React.RefObject<HTMLTableRowElement>
}

const BookkeepingCurrency = (props: Props) => {
  return <>
    <LabelledRow label={RESX.Bookkeeping.resxBookkeeping} id="bookkeepingRow" rowRef={props.rowRef}>
      <BookkeepingPaginatedDropdown
        selectIfOnlyOption
        value={props.bookkeepingCurrency.bookkeeping}
        onChange={props.bookkeepingCurrency.onBookkeepingChange}
        config={{
          hasError: false,
          isDisabled: props.isBookkeepingDisabled
        }}
      />
    </LabelledRow>
    <LabelledRow label={RESX.Financial.Currency}>
      <CurrencyDropdown
        value={props.bookkeepingCurrency.currency}
        onChange={props.bookkeepingCurrency.onCurrencyChange}
      />
    </LabelledRow>

    <ExchangeRatePickerTableRow
      bookkeepingCurrency={props.bookkeepingCurrency}
      validatorKey={props.exchangeRateValidatorKey}
      error={props.exchangeRateError}
    />
  </>;
};

export default BookkeepingCurrency;